<template>
<div>
	<v-form ref="form">
		<v-card-text>
			<InputField placeholder=" " :error="invalidLogin" :model="model" name="Login" autofocus prepend-icon="mdi-account" ref="Login" :counter="50"/>
			<PasswordField placeholder=" " :error="invalidLogin" :model="model" name="Password" ref="Password" prepend-icon="mdi-lock"/>

			<v-btn color="primary" ref="SaveBtn" @click="onSave()" depressed :loading="isAuthenticating" style="width: 100%">Logga in</v-btn>
		</v-card-text>
		<v-card-actions>
			<v-btn :color="$vuetify.theme.dark ? 'accent' : 'secondary'" text :href="ResetPasswordLink" target="_blank">Glömt lösenord</v-btn>
		</v-card-actions>
	</v-form>

	<SMSVerificationDialog ref="smsVerificationDialog"/>
</div>
</template>

<script>
import {mapActions} from 'vuex';

import InputField    from '../form/InputField.vue';
import PasswordField from '../form/PasswordField.vue';

import LocalStorage          from '../../lib/LocalStorage.js';
import Login                 from '../../models/Login.js';
import SMSVerificationDialog from '../SMSVerificationDialog.vue';

export default {
	name: 'UsernamePassword',

	components: {
		SMSVerificationDialog,
		InputField,
		PasswordField,
	},

	computed: {
		ResetPasswordLink() {
			return process.env.VUE_APP_RESET_PASSWORD_LINK;
		},
	},

	data: () => ({
		model: new Login({
			Login:    LocalStorage.get('Login'),
			Password: '',
		}),
		tabOrder: [
			'Login',
			'Password',
			'SaveBtn',
		],
		invalidLogin:     false,
		isAuthenticating: false,
	}),

	methods: {
		...mapActions(['clearSnackbar', 'setAuthenticated']),

		onSave(SMSToken) {
			this.invalidLogin = false;
			this.clearSnackbar();

			if(!this.$validateForm()) {
				return;
			}

			this.$tryCatch({
				task: async () => {
					this.isAuthenticating = true;

					const {requireSMSVerification, UserAccount, UserAppSettings, HasPlus, Supplier, HasLicensOption, EnforceBankIDAuth} = await this.$http.post('/authenticate', {
						Login:    this.model.Login,
						Password: this.model.Password,
						SMSToken,
					});

					if(requireSMSVerification) {
						this.$refs.smsVerificationDialog.show(this.model.toJSON(), this.onSave.bind(this));

						return;
					}

					if(UserAppSettings && ['dark', 'white'].includes(UserAppSettings.Theme)) {
						this.$vuetify.theme.dark = UserAppSettings.Theme === 'dark';
					}

					LocalStorage.set('Login', UserAccount.Login);
					LocalStorage.set('LoginMethod', 1);

					this.setAuthenticated({UserAccount, UserAppSettings, HasPlus, Supplier, HasLicensOption, EnforceBankIDAuth});
				},
				error: (error) => {
					this.invalidLogin = false;

					if(error.DVCode === 40100 || error.DVCode === 40400) {
						this.invalidLogin = true;
					}
				},
				finally: () => {
					this.isAuthenticating = false;
				},
			});
		},
	},
}
</script>

<style scoped>

</style>
